import { useState } from 'react';
import { Form, Input, Button, message } from "antd";
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import md5 from 'js-md5';
import { useNavigate } from 'react-router-dom';
import loginBg from '../../assets/login-bg.png';
import './Login.scss';
import useStore from "../../store";

const Item = Form.Item;

function Login() {
  const navigate = useNavigate();
  const { LoginStore } = useStore();
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    const { username, passwd } = values;
    try {
      if (username && username !== '' && passwd && passwd !== '') {
        setLoading(true);
        let passwdMd5 = md5(md5(passwd + 'twy-service'));
        await LoginStore.getToken({ username, passwd: passwdMd5 });
        navigate('/layout/home', { replace: true });
        message.success('login success');
      } else {
        message.error('username or password error');
      }
    } catch (e) {
      message.error(e.response?.data.message || 'login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login">
      <div className="login-left">
        <div className="login-left-content">
          <h1 className="login-brand">TENWAYS</h1>
          <h2 className="login-slogan">
            Ride Further.<br />
            <span className="login-slogan-highlight">Live Better.</span>
          </h2>
          <p className="login-desc">
            Sign in to access your account, manage your<br />
            e-bike and explore the TENWAYS world.
          </p>
        </div>
        <div className="login-left-illustration">
          <img src={loginBg} alt="TENWAYS e-bike" />
        </div>
      </div>

      <div className="login-right">
        <div className="login-form-wrapper">
          <h2 className="login-welcome">Welcome back</h2>
          <p className="login-welcome-sub">Sign in to continue to your TENWAYS account.</p>

          <Form onFinish={onFinish} layout="vertical" requiredMark={false}>
            <Item
              name="username"
              label="Email or Username"
            >
              <Input
                size="large"
                prefix={<UserOutlined style={{ color: '#bfbfbf' }} />}
                placeholder="Enter your email or username"
              />
            </Item>
            <Item
              name="passwd"
              label="Password"
            >
              <Input.Password
                size="large"
                prefix={<LockOutlined style={{ color: '#bfbfbf' }} />}
                placeholder="Enter your password"
              />
            </Item>
            <Item>
              <Button
                type="primary"
                htmlType="submit"
                size="large"
                block
                loading={loading}
                className="login-submit-btn"
              >
                Sign In
              </Button>
            </Item>
          </Form>
        </div>

        <div className="login-footer">
          &copy; {new Date().getFullYear()} TENWAYS. All rights reserved.
        </div>
      </div>
    </div>
  );
}

export default Login;
